import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { getAllInsumos } from "../../../../api/InsumosApi";

const ModalUsoInsumo = ({ estado, onCloseModal, onReturnValue, dataEdit }) => {
  const [insumo, setInsumo] = useState("");
  const [cantidad,setCantidad] = useState("");
  const [cantidadtotal, setCantidadTotal] = useState("");
  const [encargado, setEncargado] = useState("");
  const [cantidadactual, setCantidadActual] = useState("");
  const [ListInsumo, setListInsumo] = useState([]);

  const loaddata = async () => {
    const result = await getAllInsumos();
    const resultMapeado = result.map((item) => ({
      label: item.insumo,
      value: item.insumo,
    }));
    setListInsumo(resultMapeado);
  };

  useEffect(() => {
    if (dataEdit) {
      setInsumo(dataEdit.insumo || "");
      setCantidad(dataEdit.cantidad || "");
      setCantidadTotal(dataEdit.cantidadtotal || "");
      setEncargado(dataEdit.encargado || "");
      setCantidadActual(dataEdit.cantidadactual || "");
    } else {
      setInsumo("");
      setCantidad("");
      setCantidadTotal("");
      setEncargado("");
      setCantidadActual("");
    }
    loaddata();
  }, [dataEdit]);

  const handleGuardar = () => {
    // Validate all required fields
    if (
      !insumo ||
      !cantidad ||
      !cantidadtotal ||
      !encargado ||
      !cantidadactual
    ) {
      Swal.fire({
        title: "Datos requeridos",
        text: "Por favor complete todos los campos obligatorios",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: true,
      });
      return;
    }

    const receta = {
      idusoinsumo: dataEdit?.idusoinsumo || null,
      insumo,
      cantidad,
      cantidadtotal,
      cantidadactual,
      encargado        
    };

    onReturnValue(receta);
  };

  return (
    <Modal show={estado} onHide={onCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>{dataEdit ? "Editar Uso de Insumo" : "Nuevo Uso de Insumo"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Insumo</Form.Label>
            <Select
              options={ListInsumo || []} // Fallback to empty array
              isSearchable
              value={{value: insumo, label: insumo}}
              onChange={(e) => setInsumo(e.value)}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>cantidad</Form.Label>
            <Form.Control
              type="number"
              value={cantidad}
              required
              onChange={(e) => setCantidad(e.target.value)}
              placeholder="Cantidad por uso"
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Cantidad Total</Form.Label>
            <Form.Control
              type="number"
              value={cantidadtotal}
              required
              onChange={(e) => setCantidadTotal(e.target.value)}
              placeholder="Cantidad total"
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Cantidad Actual</Form.Label>
            <Form.Control
              type="number"
              value={cantidadactual}
              required
              onChange={(e) => setCantidadActual(e.target.value)}
              placeholder="cantidad actual faltante"
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Encargado</Form.Label>
            <Form.Control
              type="text"
              value={encargado}
              required
              onChange={(e) => setEncargado(e.target.value)}
              placeholder="Nombre del encargado"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleGuardar}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalUsoInsumo;
